import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PlayCircleIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full min-h-screen flex items-center justify-center px-4 py-20 bg-gradient-to-b from-[#0f172a] via-[#1e293b] to-[#0f172a]" data-id="element-55">
      <div className="max-w-5xl mx-auto text-center" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-57">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-8 text-white" data-id="element-58">
            Deja de pagar el costo invisible de no estar organizado
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.15
      }} className="mb-10 cursor-pointer" onClick={scrollToCompra} data-id="element-59">
          <img src="https://cdn.magicpatterns.com/uploads/6rpiEmZoCZQtKJHvido7DE/ChatGPT_Image_Apr_21__2026__04_27_31_PM-removebg-preview.png" alt="MegaPack KineEficiente - Sistema completo para kinesiólogos" className="mx-auto max-w-md md:max-w-lg lg:max-w-xl w-full drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-60" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed" data-id="element-61">
          El recurso que transforma kinesiólogos desordenados en profesionales
          organizados, rápidos y seguros… sin perder tiempo ni dudar en cada
          paciente.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex justify-center items-center" data-id="element-62">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToCompra} className="bg-yellow-400/90 text-black px-8 py-5 rounded-lg font-bold text-lg flex items-center gap-2 shadow-lg shadow-yellow-400/20 hover:shadow-yellow-400/40 transition-shadow" data-id="element-63">
            👉 Empezar ahora
            <ArrowRightIcon className="w-5 h-5" data-id="element-64" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}